module.exports = __webpack_public_path__ + "img/__icon_COILMULDE.088d3659.svg";